<template>
  <div class="sidebar"
       :data="backgroundColor">
    <!--
            Tip 1: you can change the color of the sidebar's background using: data-background-color="white | black | darkblue"
            Tip 2: you can change the color of the active button using the data-active-color="primary | info | success | warning | danger"
        -->
    <!-- -->
    <div class="sidebar-wrapper" id="style-3">
      <div class="logo">
        <a href="https://cryptolumi.com/bot"
           aria-label="sidebar mini logo"
           class="simple-text logo-mini">
          <div class="logo-img"
               :class="{'logo-img-rtl': $rtl.isRTL}">
            <img
              src=" data:image/png;base64,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"
              alt="">
          </div>
        </a>
        <a href="https://cryptolumi.com/bot" class="simple-text logo-normal">
          {{title}}
        </a>
      </div>
      <slot>

      </slot>
      <ul class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot name="links">
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="index"
                        :to="link.path"
                        :name="link.name"
                        :icon="link.icon">
          </sidebar-link>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
  import SidebarLink from "./SidebarLink";

  export default {
    props: {
      title: {
        type: String,
        default: "CryptoLumi"
      },
      backgroundColor: {
        type: String,
        default: "vue"
      },
      activeColor: {
        type: String,
        default: "success",
        validator: value => {
          let acceptedValues = [
            "primary",
            "info",
            "success",
            "warning",
            "danger"
          ];
          return acceptedValues.indexOf(value) !== -1;
        }
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide() {
      return {
        autoClose: this.autoClose,
        addLink: this.addLink,
        removeLink: this.removeLink
      };
    },
    components: {
      SidebarLink
    },
    computed: {
      /**
       * Styles to animate the arrow near the current active sidebar link
       * @returns {{transform: string}}
       */
      arrowMovePx() {
        return this.linkHeight * this.activeLinkIndex;
      },
      shortTitle() {
        return this.title.split(' ')
          .map(word => word.charAt(0))
          .join('').toUpperCase();
      }
    },
    data() {
      return {
        linkHeight: 65,
        activeLinkIndex: 0,
        windowWidth: 0,
        isWindows: false,
        hasAutoHeight: false,
        links: []
      };
    },
    methods: {
      findActiveLink() {
        this.links.forEach((link, index) => {
          if (link.isActive()) {
            this.activeLinkIndex = index;
          }
        });
      },
      addLink(link) {
        const index = this.$slots.links.indexOf(link.$vnode);
        this.links.splice(index, 0, link);
      },
      removeLink(link) {
        const index = this.links.indexOf(link);
        if (index > -1) {
          this.links.splice(index, 1);
        }
      }
    },
    mounted() {
      this.$watch("$route", this.findActiveLink, {
        immediate: true
      });
    }
  };
</script>
